import React, { useEffect, useState } from 'react';
import styles from './Dashboard.module.css';
import ApexCharts from './ApexCharts';
import apiService from '../api/apiService';

export const RoomOccupancyStatus = ({ hotelId }) => {
  const [rooms, setRooms] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [roomStatus, setRoomStatus] = useState([]);

  // Helper function to filter room occupancy based on bookings
  const filterRoomOccupancy = (rooms, bookings) => {
    const todayStr = new Date().toISOString().split('T')[0]; // Today's date in 'YYYY-MM-DD'

    // Step 1: Filter bookings for the current date
    const activeBookings = bookings.filter(booking => {
      const checkIn = new Date(booking.check_in).toISOString().split('T')[0]; // 'YYYY-MM-DD'
      const checkOut = new Date(booking.check_out).toISOString().split('T')[0]; // 'YYYY-MM-DD'
      return checkIn <= todayStr && todayStr <= checkOut; // Booking is active on the current date
    });

    // Step 2: Find the occupied room IDs
    const occupiedRoomIds = activeBookings.map(booking => booking.room);

    // Step 3: Filter rooms that are available or occupied based on the current date
    const filteredRooms = rooms.map(room => {
      const isOccupied = occupiedRoomIds.includes(room.id);
      const isAvailable = room.status === 'available';

      if (isAvailable && !isOccupied) {
        return { ...room, occupancyStatus: 'Available' }; // Available and not occupied
      } else if (isOccupied) {
        return { ...room, occupancyStatus: 'Occupied' }; // Occupied
      } else {
        return { ...room, occupancyStatus: 'Unavailable' }; // Unavailable (Not available)
      }
    });

    return filteredRooms;
  };

  // Fetch room and booking data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch room data for the given hotel ID
        const roomsRes = await apiService.get(`/rooms/?hotel=${hotelId}`);
        // Fetch booking data for the given hotel ID
        const bookingsRes = await apiService.get(`/bookings/?hotel=${hotelId}`);

        const rooms = roomsRes;
        const bookings = bookingsRes;

        // Filter room occupancy
        const filteredRooms = filterRoomOccupancy(rooms, bookings);
        setRooms(filteredRooms);
        setBookings(bookings); // Optional, can be used for other purposes if needed
      } catch (error) {
        console.error('Error fetching room or booking data:', error);
      }
    };

    fetchData();
  }, [hotelId]);

  // Calculate the number of occupied and available rooms
  const occupiedRooms = roomStatus.filter(
    room => room.occupancyStatus === 'Occupied'
  ).length;
  const availableRooms = roomStatus.filter(
    room => room.occupancyStatus === 'Available'
  ).length;

  const series = [occupiedRooms, availableRooms];
  const options = {
    labels: ['Occupied', 'Available'],
    colors: ['#00E396', '#FEB019'],
    legend: { show: false },
    dataLabels: { enabled: true },
    chart: {
      type: 'donut',
    },
  };

  return (
    <div className={styles.floorStatus}>
      <h3>Room Occupancy</h3>
      <div className={styles.floorStats}>
        <ApexCharts series={series} options={options} type="donut" />
      </div>
      <div className={styles.floorStatsLegend}>
        <div className={`${styles.legendItem} justify-content-center`}>
          <div className={styles.completedIndicator}></div>
          <span className={styles.text1}>Occupied</span>
        </div>
        <div className={`${styles.legendItem} justify-content-center`}>
          <div className={styles.pendingIndicator}></div>
          <span className={styles.text2}>Available</span>
        </div>
      </div>
    </div>
  );
};
